var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconList = function SvgIconList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.987 2.16h-9.68c-.568 0-1.013-.431-1.013-.981S4.739.196 5.306.196h9.681C15.554.196 16 .63 16 1.18s-.446.982-1.013.982ZM16 6.287c0-.55-.446-.982-1.013-.982h-9.68c-.568 0-1.013.432-1.013.982s.445.982 1.012.982h9.681c.567 0 1.013-.432 1.013-.982Zm0 5.107c0-.55-.446-.982-1.013-.982h-9.68c-.568 0-1.013.432-1.013.982s.445.982 1.012.982h9.681c.567 0 1.013-.432 1.013-.982ZM2.43 1.179C2.43.51 1.904 0 1.215 0 .567 0 0 .51 0 1.179c0 .628.527 1.178 1.215 1.178.689 0 1.215-.51 1.215-1.178Zm0 5.107c0-.668-.526-1.179-1.215-1.179C.567 5.107 0 5.617 0 6.286c0 .628.527 1.178 1.215 1.178.689 0 1.215-.51 1.215-1.178Zm0 5.107c0-.668-.526-1.179-1.215-1.179-.648 0-1.215.511-1.215 1.179 0 .628.527 1.178 1.215 1.178.689 0 1.215-.51 1.215-1.178Z",
    fill: "#1C2243",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_list.b12288ed.svg";
export { ForwardRef as ReactComponent };